export default __webpack_public_path__ + "static/thumbnail-01c3f23d63675738349cab3cbfb689dc.jpg";